import { State } from 'src/types'
import { edgeOfCommon } from '../edge'
import { hamidashiOfMiddleFingerBeltBackStyle } from '../hamidashi'
import { littleRingMergedFingerOfBeltBackStyle } from '../littleRingFinger'
import { thumbFingerOfBeltBackStyle } from '../thumbFinger'
import { beltTypeDrawer } from './beltTypeDrawer'

export const beltStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, printLeatherTypeValue?: string): Promise<void> => {
  // 小指側の指袋
  await littleRingMergedFingerOfBeltBackStyle(ctx, state?.middleLeftRingLittle?.color, state.stitch.color, printLeatherTypeValue)

  // 親指側の指袋
  await thumbFingerOfBeltBackStyle(ctx, state?.thumbIndexMiddleRight?.color, state.stitch.color, printLeatherTypeValue)

  // ベルトスタイルのハミダシ
  hamidashiOfMiddleFingerBeltBackStyle(ctx, state.hamidashi)

  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)

  // ベルトタイプ別の描画
  beltTypeDrawer(ctx, state)
}
